module.exports = __webpack_public_path__ + "img/img_01.331a1ed8.webp";